import React from 'react'
import { ArrowRight, Instagram, Star } from 'lucide-react';

function Home() {
  return (
    <div id='Home'>
        <div className='bg-[#EDF7F8] p-4 gap-8 md:gap-12 md:p-8 lg:p-16 flex flex-col md:flex-row justify-center items-center'>
            {/* Text Content */}
            <div className='flex flex-col pl-2 md:pl-8 lg:pl-24 gap-3 md:gap-4 w-full md:w-1/2'>
                <h1 className='text-[#FFA300] text-xl sm:text-2xl md:text-4xl lg:text-5xl font-handwriting text-center md:text-left'>
                    Welcome to La-Escondida Hotel
                </h1>
                <p className='text-[#16B97A] uppercase signika font-bold text-lg sm:text-xl md:text-3xl lg:text-5xl text-center md:text-left'>
                    WE ARE HERE TO SERVE YOU
                </p>
                <p className='font-bold text-lg sm:text-xl md:text-4xl lg:text-7xl alata uppercase text-center md:text-left'>
                    THE BEST FOOD
                </p>
                <p className='text-gray-400 my-3 md:my-4 text-sm sm:text-base md:text-lg lg:text-xl quicksand font-semibold w-full max-w-2xl text-center md:text-left mx-auto md:mx-0'>
                    We have meal prep, in house and outdoor catering and Workshops service delivery on-site.
                </p>
                
                {/* Buttons Section */}
                <div className='flex flex-col sm:flex-row gap-4 md:gap-8 lg:gap-24 justify-center md:justify-start items-center mt-4'>
                    <button className='bg-[#FFA300] flex gap-2 font-normal md:font-semibold cursor-pointer rounded-tl-xl rounded-br-3xl hover:bg-[#16B97A] transition-all duration-300 text-white text-sm sm:text-base md:text-md py-3 px-6 md:px-8 md:py-4 w-full sm:w-auto justify-center items-center'>
                        <p>Follow us</p>
                        <ArrowRight size={18} className='md:size-6' />
                    </button>
                    <div className='flex quicksand items-center gap-3 justify-center w-full sm:w-auto'>
                        <Instagram size={32} className='md:size-10 text-[#FFA300]'/>
                        <p className='text-sm md:text-base'>Instagram</p>
                    </div>
                </div>
                
                {/* Customer Rating */}
                <div className='flex flex-col sm:flex-row gap-4 items-center justify-center md:justify-start mt-6 md:mt-8'>
                    <img 
                        src='/image/review.png' 
                        className='h-12 w-24 sm:h-[50px] sm:w-[100px] md:h-[70px] md:w-[150px] object-contain'
                        alt='Customer reviews'
                    />
                    <div className='flex flex-col gap-2 text-center sm:text-left'>
                        <p className='text-[#16B97A] font-semibold signika text-sm md:text-base'>
                            Our Happy Customers
                        </p>
                        <p className='flex gap-1 md:gap-2 text-sm md:text-base alata justify-center sm:justify-start items-center'>
                            <Star className='text-[#FFA300] fill-[#FFA300] size-4 md:size-5'/> 
                            <span>5 Star rated</span>
                        </p>
                    </div>
                </div>
            </div>
            
            {/* Image Section */}
            <div className='w-full md:w-1/2 flex justify-center md:pr-8 lg:pr-24 mt-6 md:mt-0'>
                <div className='bg-[#FFA300] w-full max-w-md sm:max-w-lg md:w-[400px] lg:w-[500px] xl:w-[600px] h-[300px] sm:h-[350px] md:h-[400px] lg:h-[500px] xl:h-[60vh] flex flex-col items-center justify-center'
                    style={{
                        borderBottomRightRadius: '70px',
                        borderTopLeftRadius: '70px'
                    }}
                >
                    <img 
                        src='/image/HomePageFood.png' 
                        className='w-full h-full object-contain scale-90 hover:scale-95 transition-transform duration-300' 
                        alt='Delicious food from La-Escondida Hotel'
                    />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Home